import React from 'react'
import { useHistory } from 'react-router-dom'
import { useAppDispatch } from 'store'
import { clearAsyncMessage } from 'store/slices/auth/slice'
import styled from 'styled-components/macro'
import { getScaledValue } from 'utils/scale'
import { TextCalibriRegular } from '../Typography'

const ContinueWith = ({ redirect, text, icon }) => {
  const history = useHistory()
  const dispatch = useAppDispatch()

  const handleClick = () => {
    history.push(redirect)
    dispatch(clearAsyncMessage())
  }
  return (
    <Container onClick={handleClick}>
      {icon}
      <Text>{text}</Text>
    </Container>
  )
}

export default ContinueWith

const Container = styled.div`
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  position: relative;
  text-align: center;
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 100%;
  margin-top: ${getScaledValue(5, 'px')};
  & > svg {
    position: absolute;
    left: 15px;
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.3);
  }
`

const Text = styled(TextCalibriRegular)`
  text-align: center;
  display: block;
  width: 100%;
  font-size: 19px;
  padding: 3px 0;
`
